import api from '../../plugins/api';

// Проверка настройки марки перед импортом: сколько машин отдаёт Битрикс, какие поля
// нашлись по подписям, какие ДЦ не сопоставлены с базой. Ничего не импортирует
const checkBitrixMark = (mark) => api.post(`/api/crm/cars/bitrixStock/check/${encodeURIComponent(mark)}`);

export default checkBitrixMark;
